import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  
  const heroImages = [
    "/images/slider11.jpeg",
    "/images/slider3.jpeg",
    "/images/slider2.jpeg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  // ग्रामपंचायतचे स्थानिक पदाधिकारी
  const localLeaders = [
    {
      name: "सौ. शैला राजेश जाबर",
      position: "सरपंच",
      photo: "/images/sarpanchh.jpeg",
      className: "sarpanch-card",
    },
    {
      name: "सौ. मंगला शुक्राचार्य  मेहकरे",
      position: "उपसरपंच",
      photo: "/images/upsarpanch.jpeg",
      className: "upsarpanch-card",
    },
    {
      name: "श्री. तेजस घनश्याम भुजबळ",
      position: "ग्रामपंचायत अधिकारी",
      photo: "/images/sachiv.jpeg",
      className: "sachiv-card",
    },
  ];

  // राज्य स्तराचे माननीय मंत्री व पदाधिकारी
  const stateLeaders = [
    {
      name: "देवेंद्र फडणवीस",
      position: "माननीय मुख्यमंत्री",
      photo: "/images/cm.jpg",
    },
    {
      name: "एकनाथ शिंदे",
      position: "माननीय उपमुख्यमंत्री",
      photo: "/images/eknath.jpg",
    },
    {
      name: "सुनेत्रा अजित पवार",
      position: "माननीय उपमुख्यमंत्री",
      photo: "/images/sunetra.jpeg",
    },
    {
      name: "योगेश कदम",
      position: "माननीय मंत्री, पर्यावरण व पर्यटन",
      photo: "/images/yogesh.jpeg",
    },
    {
      name: "जयकुमार गोरे",
      position: "माननीय मंत्री, ग्रामविकास",
      photo: "/images/gore.jpg",
    },
  ];

  const members = [
    { sr: 1, name: "श्री. दिलीप पांडुरंग पाटील" },
    { sr: 2, name: "श्री. अशोक नामदेव घोरकणे" },
    { sr: 3, name: "सौ.विजयता विलास भोईर" },
    { sr: 4, name: "सौ. प्रमिला प्रविण वझरे" },
    
    { sr: 5, name: "सौ. कविता वैभव पाटील" },
    { sr: 6, name: "सौ. गीता सुरेश वाघ" },
    { sr: 7, name: "सौ. मंजु राजु राठोड" },
    { sr: 8, name: "सौ. ममता दिनेश घोडविंदे" },
    
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee">
          ग्रामपंचायत घोणसई - मेट | पंचायत समिती वाडा, जि. पालघर | संपर्क: 8080658326
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>ग्रामपंचायत घोणसई - मेट</h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
            <a href="/aboutus" className="hero-btn">अधिक माहिती</a>
          </div>
        </div>
      </section>

      {/* मुख्य सेक्शन */}
      <section className="section leaders-section">
        

        {/* राज्य स्तराचे माननीय मंत्री व पदाधिकारी */}
        <h3 className="state-title">माननीय मंत्री व पदाधिकारी</h3>
        <div className="leaders-grid state-leaders-grid">
          {stateLeaders.map((leader, i) => (
            <div key={i} className="leader-card state-leader">
              <div className="leader-img">
                <SafeImage src={leader.photo} alt={leader.position} />
              </div>
              <h3>{leader.position}</h3>
              <p>{leader.name}</p>
            </div>
          ))}
        </div>

        {/* ग्रामपंचायत प्रतिनिधी + सदस्य table */}
        <div className="local-leaders-and-table">
          {/* ग्रामपंचायतचे स्थानिक पदाधिकारी */}
          <div className="local-leaders">
            {localLeaders.map((leader, i) => (
              <div key={i} className={`leader-card ${leader.className}`}>
                <div className="leader-img">
                  <SafeImage src={leader.photo} alt={leader.position} />
                </div>
                <h3>{leader.position}</h3>
                <p>{leader.name}</p>
              </div>
            ))}
          </div>

          {/* सदस्यांची यादी (table) */}
          <div className="members-table-container">
            <h3 className="subtitle">ग्रामपंचायत सदस्य</h3>
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>नाव</th>
                  <th>पद</th>
                </tr>
              </thead>
              <tbody>
                {members.map((member) => (
                  <tr key={member.sr}>
                    <td>{member.sr}</td>
                    <td>{member.name}</td>
                    <td>सदस्य</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* आमची दृष्टी */}
        <div className="vision-section">
          <h2 className="title">आमची दृष्टी</h2>
          <div className="vision-grid">
            <div className="vision-card">
              <span className="vision-icon">💡</span>
              <h3>डिजिटल ग्राम</h3>
              <p>ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे.</p>
            </div>
            <div className="vision-card">
              <span className="vision-icon">🌿</span>
              <h3>पर्यावरण पूरक विकास</h3>
              <p>गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे.</p>
            </div>
            <div className="vision-card">
              <span className="vision-icon">🤝</span>
              <h3>युवा आणि महिला सबलीकरण</h3>
              <p>शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <h2 className="map-title">📍 ग्रामपंचायत घोणसई - मेट – स्थान</h2>
        <p className="map-subtitle">ग्रामपंचायत घोणसई - मेट, तालुका वाडा, जिल्हा पालघर</p>
        <div className="map-container">
          <iframe
            title="ghonsai Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d27444.98718131159!2d73.07903412469369!3d19.50008714913492!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7a01ed4c411dd%3A0xf60d5c7cc28899d2!2sGhonsai%2C%20Maharashtra%2C%20India!5e1!3m2!1sen!2sus!4v1773651849717!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Home;